import { Box, Checkbox, Radio, Typography } from '@mui/material';
import React from 'react';
import { questionTypeEnum } from '../../../../constants';
import { FormQuestionWithOptions } from '../../../../services/apiSLTP/qhse/forms/formQuestions';
import CustomTextInput from '../../../ui/CustomTextInput';

interface QuestionTypeViewerProps {
    question: FormQuestionWithOptions;
}

const QuestionTypeViewer: React.FC<QuestionTypeViewerProps> = ({ question }) => {
    switch (question.type) {
        case questionTypeEnum.MULTIPLE_CHOICE:
        case questionTypeEnum.SINGLE_CHOICE:
            return (
                <Box display="flex" flexDirection="column" gap={1}>
                    {question.options?.map((opt, idx) => (
                        <Box key={opt._id} display="flex" alignItems="center" gap={1}>
                            {question.type === questionTypeEnum.SINGLE_CHOICE ? <Radio disabled /> : <Checkbox disabled />}
                            <Typography>{opt.value}</Typography>
                        </Box>
                    ))}
                </Box>
            );

        case questionTypeEnum.TEXT_LONG:
        case questionTypeEnum.TEXT_SHORT:
            return <CustomTextInput multiline={questionTypeEnum.TEXT_LONG === question.type} placeholder="Saisir votre texte…" disabled />;

        default:
            return <CustomTextInput value={''} placeholder="Saisir votre texte…" disabled />;
    }
};

export default QuestionTypeViewer;
